import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const MACROS = [
  { key: "protein", label: "Protein", color: "#2D4A22" },
  { key: "carbs", label: "Carbs", color: "#D99C3B" },
  { key: "fat", label: "Fat", color: "#C86B5E" },
];
